import styled from 'styled-components'

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 120px;
  box-sizing: border-box;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.ai.surface};
`

export const HeaderRecommendation = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  svg {
    vertical-align: middle;
  }
`

export const DescriptionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
